import { h as __h } from "preact";
import { signal } from "@preact/signals";
import { Component } from "preact";
import { setSession } from "~/lib/session.js";
import { consumeSSONonce } from "~/lib/sso.js";
import html from "~/util/html.js";
import { search } from "~/util/router.js";
import PublicLayout from "./PublicLayout.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./SsoCallback.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./SsoCallback.module.css", import.meta.url);
const css = adopt(sheet);
const ssoErrorMessages = /** @type {Record<string, string>} */{
  invalid_request: "Invalid SSO request. Please try again.",
  invalid_state: "SSO session expired. Please try again.",
  server_error: "An error occurred. Please try again later.",
  sso_failed: "SSO authentication failed. Please try again.",
  invalid_email: "Invalid email address from SSO provider.",
  org_mismatch: "Your identity provider does not belong to this organization.",
  invalid_machine_id: "This computer is already linked to another account.",
  user_not_found: "Your account has not been provisioned. Please contact your IT administrator.",
  limit_reached: "You have reached the maximum number of devices.",
  sso_timeout: "SSO login timed out. Please try again.",
  sso_cancelled: "SSO login was cancelled.",
  sso_not_configured: "SSO is not configured for this email domain."
};
export default class SsoCallback extends Component {
  error = signal("");

  /** @override */
  componentDidMount() {
    this.completeSSOLogin();
  }
  completeSSOLogin() {
    const {
      error,
      nonce,
      token
    } = search.value;
    if (error) {
      this.error.value = ssoErrorMessages[error] || "Unable to complete SSO sign in.";
      return;
    }
    if (!token || !nonce) {
      this.error.value = "Invalid SSO callback link. Please try again.";
      return;
    }
    if (!consumeSSONonce(nonce)) {
      this.error.value = "SSO session expired. Please try again.";
      return;
    }
    setSession({
      token
    });
  }
  render() {
    return __h(PublicLayout, {
      title: "Sign in with your company",
      "class": util.textCenter
    }, this.error.value ? [__h("p", {
      "class": css.error
    }, this.error.value), __h("p", {}, __h("a", {
      href: "/login/"
    }, "Back to login"))] : [" ", __h("p", {}, "Completing sign in..."), " "]);
  }
}